module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/master-account/master-account.component.css
// module id = ./src/app/master-account/master-account.component.css
// module chunks = main